





















































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';
import { AnalysisType } from '@/components/analysis/steps/type/AnalysisStepType';

// Components
import PatientAddOrEdit from '@/components/patients/PatientAddOrEdit.vue';
import PatientDelete from '@/components/patients/PatientDelete.vue';
import PatientAcquisitionDelete from '@/components/patients/acquisition/PatientAcquisitionDelete.vue';
import PatientAcquisitionExportation from '@/components/patients/acquisition/exportation/PatientAcquisitionExportation.vue';
import DialogAcquisitionInProgress from '@/components/dialogs/DialogAcquisitionInProgress.vue';
import DialogStartAnalysisWithoutConnectedStation from '@/components/dialogs/DialogStartAnalysisWithoutConnectedStation.vue';

@Component({
  components: {
    PatientAddOrEdit,
    PatientDelete,
    PatientAcquisitionDelete,
    PatientAcquisitionExportation,
    DialogAcquisitionInProgress,
    DialogStartAnalysisWithoutConnectedStation,
  },
})
export default class PatientSidebar extends Vue {
  @Prop({ required: true }) private readonly patient!: TEntity<TPatient>;

  menu = false;
  acquisitionSelected: any = null;
  compareAcquisition: any = null;

  // Dialogs open values
  acquisitionInProgressDialog = false;
  noStationAvailableDialog = false;

  get startAcquisitionLinkLocked() {
    return this.$pdc.helper!.isDemo || !this.$pdc.entities!.stations.storedEntity.list.length;
  }
  get patientSidebarMiniVariant(): boolean {
    return this.$pdc.storage!.getUniversal('patientSidebarMiniVariant');
  }
  get route(): any {
    return this.$route;
  }
  get isResultPage() {
    return this.$route.path.includes('/result/');
  }
  get isRunningAcquisition() {
    const acquisition = this.patient!.acquisitions.find((x: any) => x._id === this.$route.params.acquisitionId)!;
    return acquisition.analysisType === AnalysisType.Running;
  }

  // Has connected station ?
  get connectedStations() {
    return this.$pdc.analysis!.entityStations!.data.filter((x: TEntity<TStation>) => x.online).length;
  }

  set patientSidebarMiniVariant(value: boolean) {
    this.$pdc.storage!.setUniversal('patientSidebarMiniVariant', value);
  }

  @Watch('acquisitionSelected', { deep: true })
  onAcquisitionChange(acquisition: any) {
    if (!!acquisition && this.$route.params.acquisitionId !== acquisition._id) {
      this.$router.push({
        path: `/patient/${this.patient._id}/result/${acquisition._id}`,
      });
    }
  }
  @Watch('compareAcquisition', { deep: true })
  onCompareAcquisitionChange(acquisition: any) {
    this.$emit('compareAcquisitionResponsiveMode', acquisition);
  }
  @Watch('route', { deep: true })
  onRouteChange() {
    if (this.route.name !== 'patient-result') this.acquisitionSelected = null;
    this.menu = false;
  }

  findByType(val: any, type: string) {
    if (type === 'icon') {
      switch (true) {
        case val.analysisType === 'podosmart':
          return '$vuetify.walking--r';
        default:
          return '$vuetify.running--r';
      }
    } else if (type === 'color') {
      switch (true) {
        case !this.$pdc.helper?.isValidActivity(val):
          return 'grey';
        case val.analysisType === 'podosmart' && this.$pdc.helper?.isDegradedActivity(val):
          return 'warning';
        case val.analysisType === 'podosmart':
          return 'accent';
        default:
          return 'success';
      }
    } else {
      switch (true) {
        case val.analysisType === 'podosmart':
          return 'walk';
        default:
          return 'run';
      }
    }
  }
  checkCurrentAnalysis(acquisitionId: TEntity<TAcquisition>['_id']) {
    return this.$route?.params?.acquisitionId === acquisitionId;
  }

  togglePatientSidebarMiniVariant() {
    this.patientSidebarMiniVariant = !this.patientSidebarMiniVariant;
    // TODO : find something else to fire highchart resize
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 200);

    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Patient Sidebar Minimized', {
      isMinimized: this.patientSidebarMiniVariant,
    });
  }

  selectAcquisition() {
    this.acquisitionSelected = this.patient
      ? this.patient.acquisitions.find((x: any) => x._id === this.$route.params.acquisitionId)
      : null;
  }

  goToAnalysisResults(acquisitionId: TEntity<TAcquisition>['_id']) {
    if (!this.$route?.params?.acquisitionId || this.$route?.params?.acquisitionId !== acquisitionId)
      this.$router.push(`/patient/${this.patient._id}/result/${acquisitionId}`);
  }
  goToAnalysisModule() {
    if (this.startAcquisitionLinkLocked) {
      this.$pdc.bus!.emit('equipments:get-kit:open');
    } else {
      if (this.$pdc.analysis!.manifestHasData) {
        this.acquisitionInProgressDialog = true;
      } else if (!this.connectedStations!) {
        this.noStationAvailableDialog = true;
      } else {
        // Analytics
        this.$pdc.analytics?.actions.trackSuccess('NewAnalysis Opened', {
          patientId: this.patient._id,
        });

        this.$router.push({
          path: '/analysis',
          query: {
            patientId: this.patient._id,
          },
        });
      }
    }
  }
  // Actions menu
  goToComparisonPage(acquisitionId: TEntity<TAcquisition>['_id']) {
    this.$router.push({
      name: 'patient-comparison',
      params: {
        acquisitionCompareId: acquisitionId,
      },
    });
  }
  openDeleteDialog(acquisitionId: TEntity<TAcquisition>['_id']) {
    (this.$refs.delete as any).open(this.patient, acquisitionId);
  }
  openExportDialog(acquisition: TEntity<TAcquisition>) {
    this.$pdc.bus!.emit('export:open', { patient: this.patient, acquisition: acquisition });
  }
  openExportExcelDialog(acquisition: TEntity<TAcquisition>) {
    this.$pdc.bus!.emit('export:excel:open', { patient: this.patient, acquisition: acquisition });
  }
  // Close dialogs
  closeAnalysisDialog() {
    this.acquisitionInProgressDialog = false;
  }
  closeNoStationDialog() {
    this.noStationAvailableDialog = false;
  }

  created() {
    this.$pdc.storage!.syncUniversal('patientSidebarMiniVariant', false);
  }
  mounted() {
    if (this.$route.params.acquisitionId && this.acquisitionSelected === null) {
      if (!this.patient) {
        this.$pdc.bus!.once('entities:patients:get-details-completed', this.selectAcquisition);
      } else if (this.patient.acquisitions) {
        this.selectAcquisition();
      }
    }
  }
  beforeDestroy() {
    this.$pdc.bus!.off('entities:patients:get-details-completed', this.selectAcquisition);
  }
}
